// 파일이 "이미지"인지 판정하는 순수 함수 모음.
// File 객체(선택 직후)와 채팅 메시지 payload({ fileNm, fileType, ... }, 서버에서 내려온 형태)
// 양쪽 모두에서 쓸 수 있게 둘 다 받는다 — 어느 쪽이든 mime이 있으면 mime을, 없으면
// 파일명 확장자를 본다.

const IMAGE_EXTENSIONS = ['png', 'jpg', 'jpeg', 'gif', 'webp', 'bmp', 'svg', 'heic', 'heif', 'avif'];

export function isImageMimeType(mime) {
  return typeof mime === 'string' && mime.toLowerCase().startsWith('image/');
}

export function extensionOf(name) {
  if (!name || typeof name !== 'string') return '';
  const idx = name.lastIndexOf('.');
  if (idx < 0 || idx === name.length - 1) return '';
  return name.slice(idx + 1).toLowerCase();
}

export function isImageExtension(name) {
  return IMAGE_EXTENSIONS.includes(extensionOf(name));
}

// file: File/Blob 객체, 또는 { type?, fileType?, mimeType?, name?, fileNm?, fileName? } 형태.
export function isImageFile(file) {
  if (!file) return false;
  const mime = file.type || file.fileType || file.mimeType;
  if (isImageMimeType(mime)) return true;
  const name = file.name || file.fileNm || file.fileName || '';
  return isImageExtension(name);
}

export default isImageFile;
